import * as React from "react";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarExportContainer,
} from "@mui/x-data-grid";
import {
  Button,
  Grid,
  InputLabel,
  Stack,
  TextField,
  Typography,
  MenuItem,
  Select,
  Toolbar,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import gridLabels from "../Labels/GridLabels";
import AKSIONER_COLUMNS from "./AksionerTableColumn";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../store/loading";
import {
  getAllFormTemplate,
  updateFormTemplate,
} from "../../store/formTemplate";
import StartingPageContent from "../StartingPage/StartingPageContent";
import { Box } from "@mui/system";
import { useLocation, useNavigate } from "react-router-dom";
import { OSHMA_TYPE } from "../../data/dummy-data";
import DialogDelete from "../UI/DialogDelete";
import ButtonAdd from "../UI/ButtonAdd";
import BoxRowButtonsIcon from "../UI/BoxRowButtonsIcon";
import RowButtonIcon from "../UI/RowButtonIcon";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import EditIcon from "@mui/icons-material/Edit";
import BottomToolbar from "../UI/BottomToolbar";
import SelectAutocomplate from "../UI/SelectAutocomplate";
import { getAllFormCategory } from "../../store/formCategory";
import { updateOshma, getOshmaById } from "../../store/oshma";
import AksionerModalEditor from "./AksionerModalEditor";
import { deleteShareholding } from "../../store/shareholding";
import { replaceNullsWithEmptyStrings } from "../../utils/replaceTextInObject";

const OshmaProfil = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const initialForm = {
    id: "",
    name: "",
    address: "",
    email: "",
    legalForm: "",
    phoneNumber: "",
    type: "",
    status: "INACTIVE",
    formCategory: {},
    satelitor: false,
  };

  const { formTemplate, currentPage, searchValueCurrent } = useSelector(
    (state) => state.formTemplate
  );
  const { oshmaById } = useSelector((state) => state.oshma);

  const stateData = location.state.oshmaData;
  const dataProp = location.state;

  const [open, setOpen] = React.useState(false);
  const [isStatusNew, setIsStatusNew] = React.useState(false);
  const [oshma, setOshma] = React.useState(initialForm);
  const [shareholde, setSharehold] = React.useState({});
  const [stateDialogDelete, setStateDialogDelete] = React.useState(false);
  const [selectRow, setSelectRow] = React.useState("");
  const [dataColumns, setDataColumns] = React.useState(AKSIONER_COLUMNS);
  const [errorValues, setErrorValues] = React.useState([]);
  const searchTypeState = React.useRef("");
  const [anchorElType, setAnchorElType] = React.useState(null);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setSharehold({
      name: "",
      percentage: "",
      oshmaId: stateData?.id,
    });
  };

  const navigate = useNavigate();

  const handleClickType = (event) => {
    setAnchorElType(event.currentTarget);
  };

  const handleCloseType = () => {
    setAnchorElType(null);
  };

  const openType = Boolean(anchorElType);

  React.useEffect(() => {
    setErrorValues([]);
    if (oshmaById) {
      const tempOshmaId = replaceNullsWithEmptyStrings(oshmaById);
      setOshma(tempOshmaId);
    } else {
      setOshma(initialForm);
    }
  }, [oshmaById, getOshmaById]);

  React.useEffect(() => {
    dispatch(getOshmaById({ id: dataProp?.oshmaData?.id }));
  }, [dataProp]);

  // const getAllData = () => {
  //   dispatch(setLoading(true));
  //   dispatch(getAllFormTemplate())
  //     .unwrap()
  //     .then(() => {
  //       dispatch(setLoading(false));
  //     })
  //     .catch(() => {
  //       dispatch(setLoading(false));
  //     });
  // };

  const [filterModel, setFilterModel] = React.useState({
    items: [
      {
        columnField: "",
        operatorValue: ">",
        value: "",
      },
    ],
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setOshma({ ...oshma, [name]: value ? value : "" });
  };

  const currentlySelected = (e) => {
    setIsStatusNew(false);
    setSharehold(e.row);
    // setInput(e.row);
    setOpen(true);
  };

  const addNew = () => {
    setIsStatusNew(true);
    setSharehold({
      name: "",
      percentage: "",
      oshmaId: stateData?.id,
    });
    setOpen(true);
  };

  const handleClickDelete = (e) => {
    const deleteRow = { oshmaId: stateData?.id, id: e.row?.id };
    setSelectRow(deleteRow);
    setStateDialogDelete(true);
  };

  const handleCloseDialogDelete = (e) => {
    setStateDialogDelete(false);
  };
  const handleDeleteFormTemplate = (e) => {
    // dispatch(deleteFormInput({ formInput: selectRow }));
    dispatch(deleteShareholding({ dataDelete: selectRow }));
    dispatch(getOshmaById({ id: stateData?.id }));
    setStateDialogDelete(false);
  };

  const saveForm = () => {
    var initialError = [];

    Object.keys(oshma).map(function (key, index) {
      if (
        oshma[key] !== "" &&
        oshma[key] !== null &&
        // typeof oshma[key] !== "object" &&
        Object.keys(oshma[key]).length !== 0
      ) {
      } else {
        initialError.push(key);
      }
    });

    // setErrorValues(initialError);

    const initialErrorTemp = initialError.filter(
      (item) =>
        item !== "id" &&
        item !== "address" &&
        item !== "phoneNumber" &&
        item !== "shareHolders"
    ); // remove id, address, phoneNumber, shareHolders item

    setErrorValues(initialErrorTemp);

    if (initialErrorTemp.length === 0) {
      dispatch(
        updateOshma({
          oshma: oshma,
          currentPage: currentPage,
          searchValueCurrent: searchValueCurrent,
        })
      );
      onBackNavigation();
    }
  };

  const onBackNavigation = () => {
    navigate(-1);
  };

  const checkError = (item) => {
    if (errorValues.find((element) => element === item)) {
      return true;
    } else {
      return false;
    }
  };
  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarExport
          printOptions={{ disableToolbarButton: true }}
          csvOptions={{
            fileName: "Indikator",
          }}
        ></GridToolbarExport>
        <Box sx={{ display: "flex", justifyContent: "flex-end", width: 1 }}>
          <ButtonAdd onClick={addNew} />
        </Box>
      </GridToolbarContainer>
    );
  }
  return (
    <StartingPageContent back onClick={onBackNavigation} pageName="Profili">
      <Box sx={{ mb: 5 }}>
        <Grid
          container
          spacing={{ xs: 2, md: 2 }}
          columns={{ xs: 1, sm: 8, md: 12, lg: 16 }}
        >
          <Grid item xs={4} sm={8} md={8}>
            <Stack spacing={2}>
              <InputLabel>Emri</InputLabel>
              <TextField
                name="name"
                autoComplete="off"
                id="outlined-basic"
                variant="outlined"
                onChange={handleInputChange}
                value={oshma.name}
                error={checkError("name")}
                helperText={checkError("name") ? "Emri është i detyruar" : null}
              />
            </Stack>
          </Grid>

          <Grid item xs={4} sm={8} md={8}>
            <Stack spacing={2}>
              <InputLabel>Personi fizik ose juridik</InputLabel>
              <TextField
                name="legalForm"
                autoComplete="off"
                id="legalForm"
                variant="outlined"
                onChange={handleInputChange}
                value={oshma?.legalForm}
                error={checkError("legalForm")}
                helperText={
                  checkError("legalForm") ? "Kjo fushë është e detyruar" : null
                }
              />
            </Stack>
          </Grid>
          <Grid item xs={2} sm={4} md={4}>
            <Stack spacing={2}>
              <InputLabel>Kategoria</InputLabel>
              <SelectAutocomplate
                disableTooltip
                textfield
                name="type"
                id="type"
                placeholder="Kërko Kategori"
                noOptionsText="Nuk ka Kategori"
                value={oshma?.type}
                onClick={handleClickType}
                source={OSHMA_TYPE}
                open={openType}
                anchorEl={anchorElType}
                onClickAway={handleCloseType}
                error={checkError("type")}
                helperText={
                  checkError("type") ? "Kategoria është e detyruar" : null
                }
                onClose={(event, reason) => {
                  if (reason === "escape") {
                    handleCloseType();
                  }
                }}
                onChange={(event, newValue, reason) => {
                  if (
                    event.type === "keydown" &&
                    event.key === "Backspace" &&
                    reason === "removeOption"
                  ) {
                    return;
                  }
                  setOshma({
                    ...oshma,
                    type: newValue?.id ? newValue?.id : "",
                  });
                  handleCloseType();
                }}
                // onchangesearch={searchItems}
                inputRef={searchTypeState}
              ></SelectAutocomplate>
            </Stack>
          </Grid>
          <Grid item xs={2} sm={4} md={4}>
            <Stack spacing={2}>
              <InputLabel>Telefon</InputLabel>
              <TextField
                name="phoneNumber"
                autoComplete="off"
                id="phoneNumber"
                variant="outlined"
                onChange={handleInputChange}
                value={oshma.phoneNumber}
                error={checkError("phoneNumber")}
                helperText={
                  checkError("phoneNumber")
                    ? "Kjo fushë është e detyruar"
                    : null
                }
              />
            </Stack>
          </Grid>
          <Grid item xs={2} sm={4} md={4}>
            <Stack spacing={2}>
              <InputLabel>E-mail</InputLabel>
              <TextField
                name="email"
                autoComplete="off"
                id="email"
                variant="outlined"
                onChange={handleInputChange}
                value={oshma?.email}
                error={checkError("email")}
                helperText={
                  checkError("email") ? "Kjo fushë është e detyruar" : null
                }
              />
            </Stack>
          </Grid>
          <Grid item xs={4} sm={8} md={8}>
            <Stack spacing={2}>
              <InputLabel>Adresa</InputLabel>
              <TextField
                name="address"
                autoComplete="off"
                id="address"
                variant="outlined"
                onChange={handleInputChange}
                value={oshma?.address}
                error={checkError("address")}
                helperText={
                  checkError("address") ? "Adresa është e detyruar" : null
                }
              />
            </Stack>
          </Grid>
          <Grid sx={{ display: "flex" }}>
            <FormControlLabel
              sx={{ marginRight: "40px", alignSelf: "flex-end" }}
              value="start"
              control={
                <Checkbox
                  name="satelitor"
                  id="satelitor"
                  defaultChecked={false}
                  checked={oshma?.satelitor}
                  onChange={(e) => {
                    setOshma({
                      ...oshma,
                      satelitor: e.target?.checked ? e.target.checked : false,
                    });
                  }}
                ></Checkbox>
              }
              label="Satelitor"
              labelPlacement="start"
            />
          </Grid>
        </Grid>
      </Box>
      <div style={{ height: 700, width: "100%" }}>
        <Typography sx={{ mb: 2 }} variant="h5">
          Aksionerët
        </Typography>
        <DataGrid
          labelRowsPerPage="Artikuj per faqe"
          disableSelectionOnClick
          columns={[
            ...dataColumns,
            {
              headerName: "",
              overflow: "hidden",
              field: "editim",
              editable: false,
              flex: 1,
              justifyContent: "flex-end",
              disableClickEventBubbling: true,
              align: "right",
              background: "red",
              headers: false,
              renderHeader: () => {},
              renderCell: (params) => (
                <BoxRowButtonsIcon>
                  <RowButtonIcon
                    onClick={(event) => {
                      currentlySelected(params);
                    }}
                  >
                    <RemoveRedEyeOutlinedIcon />
                  </RowButtonIcon>
                  <RowButtonIcon
                    onClick={(event) => {
                      currentlySelected(params);
                    }}
                  >
                    <EditIcon />
                  </RowButtonIcon>
                  <RowButtonIcon
                    delete
                    onClick={(event) => {
                      handleClickDelete(params);
                    }}
                  >
                    <Delete />
                  </RowButtonIcon>
                </BoxRowButtonsIcon>
              ),
            },
          ]}
          rows={oshma?.shareHolders ? oshma?.shareHolders : []}
          density="comfortable"
          editMode="row"
          disableColumnMenu
          localeText={gridLabels}
          componentsProps={{
            pagination: {
              labelRowsPerPage: "Rreshta per Faqe",
              showLastButton: true,
              showFirstButton: true,
            },
          }}
          components={{
            Toolbar: CustomToolbar,
          }}
          onRowDoubleClick={currentlySelected}
          filterModel={filterModel}
          onFilterModelChange={(newFilterModel) =>
            setFilterModel(newFilterModel)
          }
        />
        <DialogDelete
          open={stateDialogDelete}
          disagreedelete={handleCloseDialogDelete}
          agreedelete={handleDeleteFormTemplate}
          description=" Jeni të sigurt që doni ta fshini këtë rekord?"
        />
      </div>
      <Toolbar></Toolbar>
      <BottomToolbar>
        <Button
          variant="contained"
          sx={{
            width: "200px",
            backgroundColor: "#CD3728",
            height: "52px",
          }}
          color="error"
          onClick={onBackNavigation}
        >
          Anullo
        </Button>
        <Button
          variant="contained"
          sx={{
            width: "200px",
            backgroundColor: "primary.dark",
            height: "52px",
          }}
          onClick={saveForm}
        >
          Ruaj
        </Button>
      </BottomToolbar>
      <AksionerModalEditor
        open={open}
        onClose={handleClose}
        formname="Aksioner"
        data={shareholde}
        oshmaId={dataProp?.oshmaData?.id}
        isstatusnew={isStatusNew ? 1 : 0}
        // data={njesi}
      ></AksionerModalEditor>
    </StartingPageContent>
  );
};

export default OshmaProfil;
